import { render, staticRenderFns } from "./esta_eventos_sivigila.vue?vue&type=template&id=2ab81f22"
import script from "./esta_eventos_sivigila.vue?vue&type=script&lang=js"
export * from "./esta_eventos_sivigila.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports